// extracted by mini-css-extract-plugin
export default {"catContainer":"catSection_catContainer__I8vdu","catCol":"catSection_catCol__Ejrww","image":"catSection_image__yv7So"};